import { CopyIcon } from 'lucide-react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { useCopyToClipboard } from 'usehooks-ts'

import { Field, FieldContent, FieldError } from '@/shared/components/ui/field'
import {
	InputGroup,
	InputGroupAddon,
	InputGroupButton,
	InputGroupText,
	InputGroupTextarea,
} from '@/shared/components/ui/input-group'

export const SkusTextarea = () => {
	const { t } = useTranslation()

	const [, copyToClipboard] = useCopyToClipboard()

	return (
		<Controller
			name='skus'
			render={({ field, fieldState }) => (
				<Field className='flex w-56 shrink-0 flex-col'>
					<FieldContent className='flex h-full flex-1'>
						<InputGroup className='flex h-full flex-1'>
							<InputGroupTextarea
								className='h-full resize-none font-mono text-sm'
								value={field.value.join('\n')}
								placeholder={t('bulk_modal_invalid_selected_input')}
								onChange={(e) =>
									field.onChange(e.target.value.replace(/,/g, '\n').split(/\n/))
								}
							/>
							<InputGroupAddon align='block-start'>
								<InputGroupText className='font-mono'>SKUs list</InputGroupText>
								<InputGroupButton
									onClick={() =>
										copyToClipboard(field.value.join('\n')).then(() => {
											toast.success(
												t('bulk_modal_copied_to_clipboard', {
													defaultValue: 'Copied to clipboard',
												})
											)
										})
									}
									size='icon-xs'
									className='ml-auto'
								>
									<CopyIcon />
									<span className='sr-only'>Copy</span>
								</InputGroupButton>
							</InputGroupAddon>
							<InputGroupAddon align='block-end'>
								<InputGroupText className='text-xs'>
									{field.value?.length}/50
								</InputGroupText>
							</InputGroupAddon>
						</InputGroup>
					</FieldContent>
					<FieldError errors={[{ message: fieldState.error?.message }]} />
				</Field>
			)}
		/>
	)
}
